module.exports = __webpack_public_path__ + "img/document.2541711e.svg";